import { FAVORITE_ICON_STATE } from '../../utils/constants';
import { SmartViewElementsConfig, SmartViewGridConfig } from '../types';
import { WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { GridTitleConfig } from '../../uiElements/gridViewTitle/types';

export class GenericGridSmartViewsHelpers {
  public static configureFavoriteIcon(viewConfiguration) {
    const favoriteIconConfig = {
      icon: FAVORITE_ICON_STATE.OUTLINE,
      disabled: true,
      active: false,
    };
    if (viewConfiguration.isFavorite) {
      favoriteIconConfig.icon = FAVORITE_ICON_STATE.FILLED;
      favoriteIconConfig.disabled = false;
      favoriteIconConfig.active = true;
    }
    if (viewConfiguration.isReadOnly) {
      favoriteIconConfig.icon = FAVORITE_ICON_STATE.OUTLINE;
      favoriteIconConfig.disabled = true;
      favoriteIconConfig.active = false;
    }
    if (!viewConfiguration.isFavorite && !viewConfiguration.isRecent && !viewConfiguration.isReadOnly) {
      favoriteIconConfig.icon = FAVORITE_ICON_STATE.OUTLINE;
      favoriteIconConfig.disabled = false;
      favoriteIconConfig.active = false;
    }
    return favoriteIconConfig;
  }

  public static handleSmartViewFavoriteChanged(elements: SmartViewElementsConfig) {
    const grid = elements.gridElement;
    const smartViews = elements.smartViewsElement;

    const smartViewId = grid.viewId;
    const currentSmartView = grid.activeViewProps as unknown as SmartViewGridConfig;
    if (currentSmartView.isReadOnly && currentSmartView.isRecent) {
      return;
    }
    let newIsFavoriteFlag: boolean;
    if (!currentSmartView.isFavorite) {
      smartViews.makeSmartViewFavorite(smartViewId);
      const config = {
        disabled: false,
        icon: FAVORITE_ICON_STATE.FILLED,
        active: true,
      };
      grid.controller?.updateFavoriteIconConfig(config);
      newIsFavoriteFlag = true;
    } else {
      const config = {
        disabled: false,
        icon: FAVORITE_ICON_STATE.OUTLINE,
        active: false,
      };
      smartViews.removeFromFavorite(smartViewId);
      grid.controller?.updateFavoriteIconConfig(config);
      newIsFavoriteFlag = false;
    }
    //updating all grid related view props as the current view has changed
    (grid.activeViewProps as unknown as SmartViewGridConfig).isFavorite = newIsFavoriteFlag;
    (grid.defaultViewProps as unknown as SmartViewGridConfig).isFavorite = newIsFavoriteFlag;
    (grid.activeViewInitialProps as unknown as SmartViewGridConfig).isFavorite = newIsFavoriteFlag;
  }

  public static handleSmartViewNameUpdated(event: WebComponentEvent, elements: SmartViewElementsConfig) {
    const smartViewConfig = event.detail.smartViewItemConfiguration;
    if (elements.gridElement.viewId === smartViewConfig._id) {
      elements.gridElement.titleConfig = new GridTitleConfig(event.detail.updatedViewName);
    }
  }
}
